import React from 'react';
import { PlusIcon, CloudArrowUpIcon } from '@heroicons/react/24/solid';

const EmptyState = ({ canModify, handleCreate, handleImport }) => {
  return (
    <div className="py-12 text-center">
      <p className="mb-6 text-gray-500">No training sessions created yet</p>
      {canModify && (
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <button onClick={handleImport} className="btn-secondary">
            <CloudArrowUpIcon className="mr-2 h-5 w-5" />
            Import from Schedule
          </button>
          <button onClick={handleCreate} className="btn-primary">
            <PlusIcon className="mr-2 h-5 w-5" />
            Create Session Manually
          </button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
